import {Component, ElementRef, inject, Input, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {SelectButton} from 'primeng/selectbutton';
import {Textarea} from 'primeng/textarea';
import {UploadFile} from '../../../../../../models/consultation/UploadFile';
import {Question} from '../../../../../../models/Question';
import {ConsultationService} from '../../../../../../services/consultation.service';
import {UploadFileComponent} from '../upload-file/upload-file.component';

@Component({
    selector: 'app-question',
    imports: [
        FormsModule,
        Textarea,
        SelectButton,
        ReactiveFormsModule,
        UploadFileComponent
    ],
    templateUrl: './question.component.html',
    styleUrl: './question.component.scss'
})
export class QuestionComponent {

    // region Variables

    @Input() question: Question | null = null;
    @ViewChild('imageUploader') imageUploader: ElementRef | undefined;
    private consultationService: ConsultationService = inject(ConsultationService);
    public questionForm: FormGroup | undefined;
    public selectedFiles: File[] | undefined;

    // endregion

    // Constructor
    constructor() {
    }

    // Init
    ngOnInit() {

        // Create Question Form
        this.questionForm = new FormGroup({
            selectedAnswers: new FormControl(this.question?.data?.selectedAnswers || '', [Validators.required]),
            answer: new FormControl(this.question?.data?.answer || ''),
            files: new FormControl<File[]>([], Validators.required)
        });

        // Listen To Form Changes
        this.questionForm.valueChanges.subscribe(value => {
            this.consultationService.updateSurveyQuestion(value, this.question);
        });

    }

    // Data Change
    ngOnChanges(changes: SimpleChanges) {

        if (!this.question?.data) this.questionForm?.reset();
        this.questionForm?.get('selectedAnswers')?.patchValue(this.question?.data?.selectedAnswers || '');
        this.questionForm?.get('answer')?.patchValue(this.question?.data?.answer || '');
        this.questionForm?.get('files')?.patchValue('');
        this.selectedFiles = this.question?.data?.files;

    }

    // On Delete File
    onDeleteFile(file: any) {

        if (!this.selectedFiles || this.selectedFiles.length === 0) return;

        // Get File To Delete
        const fileToDelete = this.selectedFiles.indexOf(file);
        this.selectedFiles.splice(fileToDelete, 1);

        // Update Question Data
        this.updateFilesList();

    }

    // Select Files
    selectFiles($event: any) {

        if (!this.imageUploader) return;
        this.imageUploader.nativeElement.click();

    }

    // Update Files List
    updateFilesList() {

        if (!this.question) return;
        if (!this.question.data) this.question.data = {...this.questionForm?.value};
        this.question.data.files = this.selectedFiles;
        this.consultationService.updateSurveyQuestion(this.question.data, this.question);

    }

    // Upload Images
    uploadImages(event: any) {

        // Get Files To Upload
        const fileField = event.target as HTMLInputElement;
        if (!fileField.files || fileField.files.length <= 0) return;

        // Set Selected Files
        const files = fileField.files;
        if (!this.selectedFiles) this.selectedFiles = [];
        for (const file of files) {
            this.selectedFiles.push(file);
        }

        // Rest File Field
        fileField.value = '';

        // Update Files List
        this.updateFilesList();


    }

}
